import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import QuotationsTable from "@/components/quotations/quotations-table";

const quotationsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  numericRanges: z.string().optional(),
  /** Filtro por etiqueta (slug). */
  tag: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/quotations/")({
  validateSearch: quotationsSearchSchema,
  component: QuotationsPage,
});

function QuotationsPage() {
  const searchParams = Route.useSearch();

  return (
    <div>
      <QuotationsTable
        currentPage={searchParams.page}
        basePath="/quotations"
        searchParams={searchParams}
      />
    </div>
  );
}
